/** lag-spinner
 * 
 *  Displays a loading spinner.
 *  Derived from: https://projects.lukehaas.me/css-loaders/
 *  Other alternatives: http://tobiasahlin.com/spinkit/
 *
 *  lag-spinner {
 *      loading: Boolean
 *          If the loading spinner is visible.
 *      text: String
 *          Value to be displayed (eg a percent complete).
 *      centered: Boolean
 *          If the loading spinner should be center aligned (horizontally and vertically).
 *  }
 *  
 *  <lag-spinner loading="[[!someData]]"></lag-spinner>
 *
 *  Styling:
 *      --lag-spinner-color
 *      --lag-spinner-backgroundColor
 */

import { PolymerElement } from '@polymer/polymer/polymer-element.js';

import '@polymer/paper-spinner/paper-spinner.js';

import { defineElement } from '../../utility/defineElement.js';

import { template } from './lag-spinner.html.js';

defineElement(class extends PolymerElement {

    static get is() { return 'lag-spinner'; }

    static get template() { return template; }

    static get properties() {
        return {
            loading: {
                type: Boolean,
                value: false,
                observer: '_observeLoading'
            },

            text: {
                type: Number,
                value: null
            }
        };
    }

    _observeLoading(newLoading, oldLoading) {
        if (newLoading === oldLoading) return;

        this.$.container.classList.toggle('loading', newLoading);
    }
});